import { version } from '../../../package.json'
export function useVersion() {
    return version
}
